import React from 'react';
import { IconProps } from './types';

const RepeatIcon = ({ className }: IconProps): React.ReactElement => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M10.83 12.525h-4.5a.5.5 0 010-1h4.5a3.17 3.17 0 002.42-5.222.5.5 0 11.75-.648 4.17 4.17 0 01-3.17 6.87zM2.842 11.692a.5.5 0 01-.317-.115A4.173 4.173 0 015.17 4.182h5.945a.501.501 0 01-.068 1H5.17a3.173 3.173 0 00-2 5.623.5.5 0 01-.318.885l-.01.002z" />
    <path d="M7.675 14.27a.5.5 0 01-.28-.088l-2.538-1.725a.5.5 0 11.563-.827l2.537 1.725a.5.5 0 01-.282.912v.003z" />
    <path d="M5.137 12.525a.5.5 0 01-.282-.912l2.537-1.725a.5.5 0 11.563.827L5.417 12.44a.5.5 0 01-.28.085zM11.702 5.292a.5.5 0 01-.28-.087L8.885 3.48a.5.5 0 01.562-.828l2.538 1.725a.5.5 0 01-.283.913v.002z" />
    <path d="M9.117 7a.5.5 0 01-.275-.918l2.588-1.707a.5.5 0 01.547.838L9.39 6.907A.5.5 0 019.117 7z" />
  </svg>
);

export default RepeatIcon;
